export const STRIPE_FORM_ID = 'StripeForm'
